import React from 'react';
import useCondition from '../../../useCondition';
import useFilterModalContext from '../../useFilterModalContext';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {condition, setCondition} = useCondition();

  if (!condition?.employeeNumber?.from && !condition?.employeeNumber?.to) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">従業員数</h4>
        <button
          onClick={() => setFilterType('employeeNumber')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setCondition({employeeNumber: {}})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
          {condition.employeeNumber.from
            ? `${condition.employeeNumber.from}人`
            : '未設定'}
        </span>
        <span className="text-c-light">~</span>
        <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
          {condition.employeeNumber.to
            ? `${condition.employeeNumber.to}人`
            : '未設定'}
        </span>
      </div>
    </div>
  );
};
